// The answer of GET /workspace, in a leaf with no import: the gate hook (`services/workspace.ts`) and the registry's
// adapter (`workspace-service.ts`, which is in the entry chunk and may not reach the services layer) read it here, so the
// two cannot drift on the shape or on the query key.

/** The gate query's key (`kKeys.workspace` is this). */
export const K8S_WORKSPACE_KEY = ['k8s2', 'workspace'] as const;

/**
 * The `workspace` of the body: null while the organization has no tenant. Like `pick` (`_shared.ts`), a body without
 * the key is read as the resource itself; absent altogether is null.
 */
export function readK8sWorkspace<T>(body: unknown): T | null {
  const v = body && typeof body === 'object' && 'workspace' in (body as object) ? (body as { workspace: unknown }).workspace : body;
  return (v as T | undefined) ?? null;
}
